/* eslint semi: 1 */
import _ from 'lodash';
import EventBus from '@/components/mixins/event-bus-mixin';
import AuthMixin from '@/components/mixins/auth-mixin';

export default {
  name: 'legalComponent',
  inject: [
    '$utils'
  ],
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {
      legalItems: [
        {
          title: this.$t('legal.endUserLicenseAgreement'),
          isVisible: !_.isEmpty(CONFIG.EXTERNAL_LINKS.eula),
          webLink: CONFIG.EXTERNAL_LINKS.eula
        },
        {
          title: this.$t('legal.generalTermsAndConditionsOfSale'),
          isVisible: CONFIG.HAS_TERMS_OF_SALE,
          pdfLink: '/static/docs/SpinetiX-General-Terms-and-Conditions-of-Sale.pdf'
        },
        {
          title: this.$t('legal.termsOfService'),
          isVisible: true,
          pdfLink: '/static/docs/Terms of Service.pdf'
        },
        {
          title: this.$t('legal.privacyPolicy'),
          isVisible: true,
          pdfLink: '/static/docs/Privacy Notice.pdf'
        },
        {
          title: this.$t('legal.cookieNotice'),
          isVisible: !_.isEmpty(CONFIG.CMP_SCRIPTS),
          webLink: 'https://arya.spinetix.cloud/cookie-notice'
        }
      ]
    };
  },
  computed: {
    isActivate () {
      return this.$utils.isPageForLicenses();
    }
  },
  methods: {
    async handleDownloadFile (pdfLink, title) {
      if (_.isEmpty(pdfLink)) {
        return;
      }

      const matchFilename = pdfLink.match(/\/([^/]+)$/);
      let filename = '';

      if (matchFilename) {
        filename = matchFilename[1];
      } else if (title) {
        filename = `${title}.pdf`;
      }

      this.$utils.downloadDocument({
        url: pdfLink,
        label: filename,
        onError: (error) => {
          EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
            type: 'error',
            alert: {
              message: error.response ? error.response?.data.message ?? error.message : this.$t('errors.failedToDownloadFile')
            }
          });
        }
      });
    }
  },
  async mounted () {
    // Check if the session is not empty; if so, call Auth to display the main navigation.
    if (!_.isEmpty(await this.fetchAuthSession())) {
      this.isAuthenticated({});
    }
  }
};
